var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeurotolgeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 164 42",
    style: {
      enableBackground: "new 0 0 164 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#282828}.st1{fill:#ef6650}.st2{fill:#7268d8}.st3{fill:#e0b12b}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Neurot6lge"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Neurotolge-1920x1080",
    transform: "translate(-241 -25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(241.52 25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TartuNLP",
    transform: "translate(.48)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    className: "st0",
    cx: 91,
    cy: 18.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_1_",
    className: "st0",
    cx: 91,
    cy: 14.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_2_",
    className: "st0",
    cx: 91,
    cy: 10.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3_",
    className: "st0",
    cx: 98.4,
    cy: 10.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_4_",
    className: "st0",
    cx: 102.2,
    cy: 14.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_5_",
    className: "st0",
    cx: 91,
    cy: 6.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_6_",
    className: "st1",
    cx: 94.9,
    cy: 6.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_7_",
    className: "st0",
    cx: 91,
    cy: 2.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_8_",
    className: "st0",
    cx: 106.2,
    cy: 18.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_9_",
    className: "st0",
    cx: 106.2,
    cy: 14.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_10_",
    className: "st0",
    cx: 106.2,
    cy: 10.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_11_",
    className: "st0",
    cx: 106.2,
    cy: 6.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_12_",
    className: "st0",
    cx: 106.2,
    cy: 2.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_13_",
    className: "st0",
    cx: 112.6,
    cy: 18.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_14_",
    className: "st0",
    cx: 116.5,
    cy: 18.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_15_",
    className: "st0",
    cx: 120.4,
    cy: 18.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_16_",
    className: "st2",
    cx: 112.6,
    cy: 14.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_17_",
    className: "st0",
    cx: 112.6,
    cy: 10.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_18_",
    className: "st0",
    cx: 112.6,
    cy: 6.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_19_",
    className: "st0",
    cx: 112.6,
    cy: 2.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_20_",
    className: "st0",
    cx: 125.9,
    cy: 18.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_21_",
    className: "st1",
    cx: 149,
    cy: 18.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_22_",
    className: "st0",
    cx: 125.9,
    cy: 14.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_23_",
    className: "st0",
    cx: 129.8,
    cy: 14.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_24_",
    className: "st0",
    cx: 133.7,
    cy: 14.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_25_",
    className: "st2",
    cx: 156.9,
    cy: 14.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_26_",
    className: "st0",
    cx: 125.9,
    cy: 10.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_27_",
    className: "st0",
    cx: 125.9,
    cy: 6.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_28_",
    className: "st0",
    cx: 141.3,
    cy: 6.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_29_",
    className: "st3",
    cx: 149.1,
    cy: 6.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_30_",
    className: "st2",
    cx: 152.9,
    cy: 2.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_31_",
    className: "st0",
    cx: 141.3,
    cy: 10.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_32_",
    className: "st3",
    cx: 153,
    cy: 10.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_33_",
    className: "st1",
    cx: 160.8,
    cy: 10.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_34_",
    className: "st3",
    cx: 125.9,
    cy: 2.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_35_",
    className: "st0",
    cx: 129.8,
    cy: 2.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_36_",
    className: "st0",
    cx: 133.6,
    cy: 2.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_37_",
    className: "st0",
    cx: 137.5,
    cy: 14.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_38_",
    className: "st0",
    cx: 137.4,
    cy: 2.8,
    rx: 1.9,
    ry: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st0",
    d: "M6.2 21.5V4.7H-.1V.9h16.7v3.8h-6.3v16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st0",
    d: "m28.7 21.5-1.1-2.7h-8.1l-1.1 2.7H14l8.9-21h1.4l8.8 21h-4.4zm-2.5-6.1-2.6-7-2.6 7h5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    className: "st0",
    d: "M51.3 21.5h-4.6l-5.1-7.3h-3v7.3h-4.1V.9H42c2.1 0 3.8.6 5.1 1.8 1.3 1.2 2.1 3 2 4.8 0 1.2-.3 2.4-.9 3.5-.6 1-1.5 1.9-2.6 2.4l5.7 8.1zM38.6 4.6v5.9H42c.8 0 1.6-.2 2.2-.8.5-.6.8-1.4.8-2.2 0-.8-.3-1.6-.8-2.1-.6-.6-1.4-.9-2.2-.8h-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1_",
    className: "st0",
    d: "M56.9 21.5V4.7h-6.3V.9h16.8v3.8H61v16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2_",
    className: "st0",
    d: "M69.3 13V.9h4.1v12.4c0 1.5.4 2.6 1.2 3.5 1.8 1.6 4.5 1.6 6.3 0 .8-.8 1.2-2 1.2-3.5V.9h4.1V13c0 2.7-.8 4.8-2.4 6.5-1.6 1.6-3.6 2.4-6 2.4-2.5 0-4.5-.8-6.1-2.4-1.6-1.6-2.4-3.8-2.4-6.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "NEUROT\\xD5LGE",
    className: "st0",
    d: "M9.3 41.2V29.8H7.9v10.1c-.9-1.7-1.8-3.4-2.8-5.1l-2.7-4.9H.3v11.4h1.4V31.2c.9 1.7 1.8 3.4 2.8 5.1l2.7 4.9h2.1zm12.4-10v-1.3h-7.3v11.4h7.5V40h-6v-3.9h5.5v-1.3h-5.5v-3.6h5.8zm12.6-1.4h-1.5v7.1c0 2.1-1 3.2-2.7 3.2s-2.8-1.1-2.8-3.2v-7.1h-1.5V37c0 2.9 1.5 4.5 4.2 4.5s4.2-1.6 4.2-4.5v-7.2zm4.9 0v11.4h1.5v-4.8h2c1.2 0 1.7.4 2.2 1.8l1 3h1.6L46.4 38c-.5-1.4-.9-1.9-1.7-2.1 1.3-.3 2.2-1.4 2.2-2.8 0-1.9-1.2-3.1-4-3.1h-3.7zm1.5 1.3h2c1.7 0 2.6.6 2.6 1.9 0 1.2-.7 2.1-2.5 2.1h-2.1v-4zm15-1.5c-3.2 0-5.2 2.3-5.2 5.9s2 5.9 5.2 5.9 5.2-2.3 5.2-5.9-2.1-5.9-5.2-5.9zm0 1.4c2.2 0 3.6 1.8 3.6 4.6s-1.4 4.6-3.6 4.6-3.6-1.8-3.6-4.6 1.3-4.6 3.6-4.6zm16.7.2v-1.3h-9.3v1.3H67v10.1h1.5V31.2h3.9zm9.3-4.2c-.1.5-.3.8-.7.8-.7 0-1.3-.8-2.2-.8-.9 0-1.6.7-1.6 1.8h.8c0-.5.3-.8.7-.8.7 0 1.3.8 2.2.8.9 0 1.6-.7 1.6-1.8h-.8zm-1.9 2.6c-3.2 0-5.2 2.3-5.2 5.9s2 5.9 5.2 5.9 5.2-2.3 5.2-5.9-2-5.9-5.2-5.9zm0 1.4c2.2 0 3.6 1.8 3.6 4.6s-1.4 4.6-3.6 4.6-3.6-1.8-3.6-4.6 1.4-4.6 3.6-4.6zm10.9 8.9V29.8h-1.5v11.4h7.3v-1.3h-5.8zM104 29.6c-3.2 0-5.2 2.3-5.2 6 0 3.6 1.8 5.9 4.8 5.9 1.6 0 3-.7 3.6-1.8v1.6h1.3v-6H104v1.3h3.1c0 2.7-1.4 3.7-3.2 3.7-2.2 0-3.5-1.7-3.5-4.6 0-2.9 1.4-4.6 3.6-4.6 1.6 0 2.7.8 3 2.3h1.6c-.3-2.4-2-3.8-4.6-3.8zm16.7 1.6h-5.9v3.6h5.5v1.3h-5.5V40h6v1.3h-7.5V29.8h7.3v1.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeurotolgeLogo);
export default __webpack_public_path__ + "static/media/neurotolge-logo.90230b301bf1945ceef70eedd23d3cea.svg";
export { ForwardRef as ReactComponent };